import { createAction, props } from '@ngrx/store';

const PREFIX = '[ConversationalChatStore]';

export const setSessionId = createAction(
  `${PREFIX} Set SessionId`,
  props<{ conversationalChatSessionId: string }>()
);
